import { render, staticRenderFns } from "./Findir.vue?vue&type=template&id=35a64631"
import script from "./Findir.vue?vue&type=script&lang=js"
export * from "./Findir.vue?vue&type=script&lang=js"
import style0 from "./Findir.vue?vue&type=style&index=0&id=35a64631&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports